import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'
import { ListingResponse } from '~in-app/types/api.dto'

import { LicenseListQuery, Licenses } from './types'

export const fetchLicenseList = async (params?: { abortCtrl?: AbortController | AbortSignal, query?: LicenseListQuery }) => {
  return wretchClient
    .url('/admin/1.0/sites/licenses')
    .signal(params?.abortCtrl)
    .query(params?.query || {})
    .get()
    .json<ListingResponse<Licenses>>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const fetchLicenseContents = async (params: { id: string, certNum: string, abortCtrl?: AbortController | AbortSignal }) => {
  return wretchClient
    .url(`/admin/1.0/sites/licenses/${params.id}/contents`)
    .signal(params?.abortCtrl)
    .get()
    .blob()
    .then((blob) => {
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `${params.certNum}.lic`
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
      return true
    })
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const fetchLicenseDetails = async (params: { id: string, abortCtrl?: AbortController | AbortSignal }) => {
  return wretchClient
    .url(`/admin/1.0/sites/licenses/${params.id}`)
    .signal(params?.abortCtrl)
    .get()
    .json<[Licenses]>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const deleteLicense = async (id: string) => {
  return wretchClient
    .url(`/admin/1.0/sites/licenses/${id}`)
    .delete()
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const addLicense = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/sites/licenses`)
    .post(value)
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
export const updateLicense = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/sites/licenses`)
    .put(value)
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
